@if (eventDetail) {
  <div class="container">
    <div class="row" [formGroup]="bookingDetailsForm">
      <div class="col-5">
        <div class="room-header">
          <div class="image-container">
            @if (
              eventDetail.roomDetails.photos &&
              eventDetail.roomDetails.photos.length > 0
            ) {
              <img
                [ngSrc]="eventDetail.roomDetails.photos[0].url"
                alt="Room photo"
                fill />
            }
          </div>
          <div>
            <p class="ui-heading-4-bold">
              {{ eventDetail.roomDetails.roomName }}
            </p>
            <p class="ui-heading-4-bold">
              {{ eventDetail.roomDetails.siteName }}
              {{ eventDetail.roomDetails.buildingName }}
              {{ eventDetail.roomDetails.floorCode }}
            </p>
            <p class="ui-label-s-bold">
              Capacity: up to {{ eventDetail.roomDetails.capacity }} people
            </p>
            <br />
            <button
              rds-icon-button
              size="m"
              #popover="rdsPopover"
              (click)="popover.toggle()"
              [rdsPopover]="popoverContent">
              <rds-icon namespace="outlined" icon="administration"></rds-icon>
            </button>
            <ng-template #popoverContent>
              <rds-popover-text-content>
                <h4 rds-popover-header>Room configuration</h4>
                <div rds-popover-paragraph>
                  @if (eventDetail.roomDetails.description) {
                    <p class="ui-label-s-bold">Description:</p>
                    <p class="ui-label-s">
                      {{ eventDetail.roomDetails.description }}
                    </p>
                  }
                  @if (eventDetail.roomDetails.manageSpaceConfiguration) {
                    <p class="ui-label-s-bold">Active:</p>
                    <p class="ui-label-s">
                      {{
                        eventDetail.roomDetails.manageSpaceConfiguration.active
                      }}
                    </p>
                    <p class="ui-label-s-bold">Automatic approval:</p>
                    <p class="ui-label-s">
                      {{
                        eventDetail.roomDetails.manageSpaceConfiguration
                          .automaticApproval
                      }}
                    </p>
                  }

                  @if (
                    eventDetail.roomDetails.manageSpaceConfiguration &&
                    eventDetail.roomDetails.manageSpaceConfiguration
                      .durationRange &&
                    eventDetail.roomDetails.manageSpaceConfiguration.durationRange.min.hasOwnProperty(
                      'minutes'
                    )
                  ) {
                    <p class="ui-label-s-bold">Meeting duration range:</p>
                    <p class="ui-label-s">
                      Min:
                      {{
                        eventDetail.roomDetails.manageSpaceConfiguration
                          .durationRange.min.days
                      }}
                      days,
                      {{
                        eventDetail.roomDetails.manageSpaceConfiguration
                          .durationRange.min.hours
                      }}
                      hours,
                      {{
                        eventDetail.roomDetails.manageSpaceConfiguration
                          .durationRange.min.minutes
                      }}
                      minutes
                    </p>
                    <p class="ui-label-s">
                      Max:
                      {{
                        eventDetail.roomDetails.manageSpaceConfiguration
                          .durationRange.max.days
                      }}
                      days,
                      {{
                        eventDetail.roomDetails.manageSpaceConfiguration
                          .durationRange.max.hours
                      }}
                      hours,
                      {{
                        eventDetail.roomDetails.manageSpaceConfiguration
                          .durationRange.max.minutes
                      }}
                      minutes
                    </p>
                  }

                  @if (
                    eventDetail.roomDetails.manageSpaceConfiguration;
                    as config
                  ) {
                    @if (config.blockingTimes) {
                      <p class="ui-label-s-bold">Room blocking time:</p>
                      @for (
                        blockingTime of config.blockingTimes;
                        track $index
                      ) {
                        <p class="ui-label-s">
                          {{ blockingTime.from }} - {{ blockingTime.to }}
                        </p>
                      }
                    }
                  }
                </div>
              </rds-popover-text-content>
            </ng-template>
          </div>
        </div>
        <div class="requester-details">
          <div>
            <p class="ui-label-l-bold">Requester:</p>
            <rds-avatar size="m" [disableInteractions]="true" class="user-icon">
              @if (eventDetail.bookingDetails.requester.photo) {
                <img
                  rds-avatar-image
                  [ngSrc]="eventDetail.bookingDetails.requester.photo"
                  fill
                  alt="requester avatar"
                  referrerpolicy="no-referrer" />
              } @else {
                <rds-icon
                  rds-avatar-icon
                  namespace="outlined"
                  icon="user"></rds-icon>
              }
            </rds-avatar>
            <a
              rds-link
              standalone
              [rdsTooltip]="eventDetail.bookingDetails.requester.email"
              type="secondary"
              [href]="'mailto:' + eventDetail.bookingDetails.requester.email"
              target="_blank">
              {{ eventDetail.bookingDetails.requester.fullName }}
              <rds-icon namespace="outlined" icon="email" />
            </a>
          </div>
          <div>
            <p class="ui-label-l-bold">Requested date:</p>
            <p class="ui-label-l">
              {{
                eventDetail.bookingDetails.createTime
                  | date: 'dd MMM yyyy, HH:mm'
              }}
            </p>
          </div>
          @if (
            eventDetail.bookingDetails.onBehalfParticipants?.length &&
            !isEditMode()
          ) {
            @for (
              onBehalf of eventDetail.bookingDetails.onBehalfParticipants;
              track onBehalf.email
            ) {
              <div>
                <p class="ui-label-l-bold">On behalf:</p>
                <rds-avatar
                  size="m"
                  [disableInteractions]="true"
                  class="user-icon">
                  @if (onBehalf.photo) {
                    <img
                      rds-avatar-image
                      [ngSrc]="onBehalf.photo"
                      fill
                      alt="requester avatar"
                      referrerpolicy="no-referrer" />
                  } @else {
                    <rds-icon
                      rds-avatar-icon
                      namespace="outlined"
                      icon="user"></rds-icon>
                  }
                </rds-avatar>
                <a
                  rds-link
                  standalone
                  [rdsTooltip]="onBehalf.email"
                  type="secondary"
                  [href]="'mailto:' + onBehalf.email"
                  target="_blank">
                  {{ onBehalf.fullName }}
                  <rds-icon namespace="outlined" icon="email" />
                </a>
              </div>
            }
          } @else {
            <div class="pb-5 pt-5">
              <rds-switch [formControl]="bookOnBehalfControl">
                Book on behalf
              </rds-switch>
            </div>

            @if (bookOnBehalfControl.value) {
              <div class="on-behalf-list" formArrayName="onBehalfEmails">
                <!--
                  Track the control, not the index: `formControlName` binds
                  once per view, so an index-tracked view reused after a
                  removal would stay wired to the deleted control.
                -->
                @for (
                  onBehalfControl of onBehalfEmails.controls;
                  track onBehalfControl;
                  let index = $index
                ) {
                  <div class="on-behalf-person">
                    <div class="on-behalf-row">
                      <bsh-user-search-autocomplete
                        class="on-behalf-input"
                        [config]="{
                          label:
                            index === 0
                              ? 'Booking requester'
                              : 'Additional booking requester',
                          placeholder: 'Search user by name or email',
                        }"
                        [excludeCurrentUser]="true"
                        [formControlName]="index">
                      </bsh-user-search-autocomplete>
                      <div class="on-behalf-remove">
                        <button
                          rds-icon-button
                          type="button"
                          size="m"
                          [disabled]="onBehalfControl.disabled"
                          [rdsTooltip]="'Remove this person'"
                          (click)="removeOnBehalfPerson(index)">
                          <rds-icon
                            icon="delete"
                            namespace="outlined"></rds-icon>
                        </button>
                      </div>
                    </div>
                    @if (onBehalfControl.errors) {
                      <div class="error mb-3">
                        <rds-icon
                          icon="warning_circle"
                          namespace="outlined"
                          class="error-icon c-300-dark-red"></rds-icon>
                        <p class="error-text c-300-dark-red">
                          @if (onBehalfControl.errors['onBehalfIsRequester']) {
                            The booking requester cannot be added as an on
                            behalf person
                          } @else {
                            This field is required
                          }
                        </p>
                      </div>
                    }
                  </div>
                }
              </div>
              @if (onBehalfEmails.errors?.['duplicateOnBehalf']) {
                <div class="error mb-3">
                  <rds-icon
                    icon="warning_circle"
                    namespace="outlined"
                    class="error-icon c-300-dark-red"></rds-icon>
                  <p class="error-text c-300-dark-red">
                    The same person cannot be added twice
                  </p>
                </div>
              }
              @if (canAddOnBehalfPerson) {
                <button
                  rds-text-button
                  type="button"
                  (click)="addOnBehalfPerson()">
                  <rds-icon icon="plus" namespace="outlined"></rds-icon>
                  Add another person
                </button>
              }
            }
          }
          <div class="input-wrapper">
            <rds-form-field labelPosition="top">
              <rds-control-label>Additional Information</rds-control-label>
              <textarea rdsInput formControlName="additionalInfo"></textarea>
            </rds-form-field>
          </div>
        </div>
        @if (
          eventDetail.roomDetails.features &&
          eventDetail.roomDetails.features.length > 0
        ) {
          <div class="room-details">
            <p class="ui-label-l-bold">Room Includes</p>
            <div class="room-includes">
              @for (
                feature of eventDetail.roomDetails.features;
                track feature.id
              ) {
                <p class="ui-label-l">{{ feature.name }}</p>
              }
            </div>
          </div>
        }
        @if (layouts().length > 0) {
          <div class="container layout-container">
            <div class="row">
              <div class="col-7">
                <div class="form-control">
                  <rds-form-field labelPosition="top">
                    <rds-control-label> Select Layout </rds-control-label>
                    <rds-select formControlName="roomLayoutUUID">
                      @if (!hasActiveLayouts()) {
                        <rds-select-option [value]="null">
                          None
                        </rds-select-option>
                      }
                      @for (layout of layouts(); track layout.layoutDexUUID) {
                        <rds-select-option
                          [value]="layout"
                          [disabled]="!layout.active && isEditMode()">
                          {{ layout.layoutName }}
                          @if (updatedLayoutIds().has(layout.layoutDexUUID)) {
                            (UPDATED)
                          }
                        </rds-select-option>
                      }
                    </rds-select>
                    @if (
                      bookingDetailsForm.controls.roomLayoutUUID.errors?.[
                        'required'
                      ]
                    ) {
                      <rds-control-error>Layout is required</rds-control-error>
                    }
                    @if (
                      bookingDetailsForm.controls.roomLayoutUUID.errors?.[
                        'inactiveLayout'
                      ]
                    ) {
                      <rds-control-error
                        >Selected layout is no longer active. Please choose a
                        different one.</rds-control-error
                      >
                    }
                  </rds-form-field>
                  @if (bookingDetailsForm.controls.roomLayoutUUID.value) {
                    <p class="ui-label-s">
                      Layout capacity:
                      {{
                        bookingDetailsForm.controls.roomLayoutUUID.value
                          .capacity.min
                      }}
                      -
                      {{
                        bookingDetailsForm.controls.roomLayoutUUID.value
                          .capacity.max
                      }}
                    </p>
                    <p class="ui-label-s">Layout setup time:</p>
                    <p class="ui-label-s">
                      {{
                        bookingDetailsForm.controls.roomLayoutUUID.value
                          .setupTime.before
                      }}
                      minutes before -
                      {{
                        bookingDetailsForm.controls.roomLayoutUUID.value
                          .setupTime.after
                      }}
                      minutes after
                    </p>
                  }
                </div>
              </div>
              <div class="col-5">
                @if (
                  bookingDetailsForm.controls.roomLayoutUUID.value &&
                  bookingDetailsForm.controls.roomLayoutUUID.value.imageUrl
                ) {
                  <div class="layout-image">
                    <img
                      alt="layout-image"
                      [ngSrc]="
                        bookingDetailsForm.controls.roomLayoutUUID.value
                          .imageUrl
                      "
                      fill />
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
      <div class="col-7">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <rds-form-field labelPosition="top">
                <rds-control-label> Event name </rds-control-label>
                <input rdsInput formControlName="eventName" />
                @if (bookingDetailsForm.controls.eventName.errors) {
                  <rds-control-error>
                    This field is required
                  </rds-control-error>
                }
              </rds-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <rds-form-field labelPosition="top">
                <rds-control-label>Event Date/Time</rds-control-label>
                <rds-date-range-input
                  [rangePicker]="rangePicker"
                  [min]="minDate">
                  <input
                    rdsStartDate
                    placeholder="Start date"
                    formControlName="startDate" />
                  <input
                    rdsEndDate
                    placeholder="End date"
                    formControlName="endDate" />
                </rds-date-range-input>
                <rds-datepicker-toggle
                  rds-control-suffix></rds-datepicker-toggle>
                <rds-date-range-picker
                  #rangePicker
                  showToggle="false"
                  [dateClass]="dateClass">
                </rds-date-range-picker>
                @if (bookingDetailsForm.controls.startDate.invalid) {
                  <rds-control-error>
                    Date cannot be from the past
                  </rds-control-error>
                }
              </rds-form-field>
            </div>
            <div class="col-6">
              <div class="flex">
                <div>
                  <rds-form-field labelPosition="top">
                    <rds-control-label
                      >No. of People (in room)</rds-control-label
                    >
                    <input
                      rdsInput
                      type="number"
                      formControlName="numberOfPeople" />
                    @if (
                      bookingDetailsForm.controls.numberOfPeople.errors?.['max']
                    ) {
                      <rds-control-error>
                        Maximum capacity:
                        {{
                          bookingDetailsForm.controls.roomLayoutUUID.value
                            ?.capacity?.max ?? eventDetail.roomDetails.capacity
                        }}
                      </rds-control-error>
                    }
                    @if (
                      bookingDetailsForm.controls.numberOfPeople.errors?.['min']
                    ) {
                      <rds-control-error>
                        Minimum capacity:
                        {{
                          bookingDetailsForm.controls.roomLayoutUUID.value
                            ?.capacity?.min ??
                            eventDetail.roomDetails.minCapacity
                        }}
                      </rds-control-error>
                    }
                  </rds-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="flex">
                <rds-form-field labelPosition="top">
                  <rds-control-label>Start time</rds-control-label>
                  <input
                    rdsInput
                    [matTimepicker]="startPicker"
                    [placeholder]="'HH:mm'"
                    matTimepickerMin="07:00"
                    matTimepickerMax="23:00"
                    formControlName="startHour" />
                  <mat-timepicker-toggle
                    rds-control-suffix
                    [for]="startPicker" />
                  <mat-timepicker #startPicker />
                  @if (bookingDetailsForm.errors?.['timeNotValid']) {
                    <rds-control-error>
                      Start time should be before end time
                    </rds-control-error>
                  } @else if (bookingDetailsForm.errors?.['timeFromPast']) {
                    <rds-control-error>
                      Event cannot start in the past
                    </rds-control-error>
                  } @else if (bookingDetailsForm.errors?.['durationTooShort']) {
                    <rds-control-error>
                      Meeting duration is too short
                    </rds-control-error>
                  } @else if (bookingDetailsForm.errors?.['durationTooLong']) {
                    <rds-control-error>
                      Meeting duration is too long
                    </rds-control-error>
                  } @else if (bookingDetailsForm.errors?.['blockingOverlap']) {
                    <rds-control-error>
                      Meeting overlaps with blocking time
                    </rds-control-error>
                  }
                </rds-form-field>
                <rds-form-field labelPosition="top">
                  <rds-control-label>End time</rds-control-label>
                  <input
                    rdsInput
                    [matTimepicker]="endPicker"
                    [placeholder]="'HH:mm'"
                    matTimepickerMin="07:00"
                    matTimepickerMax="23:00"
                    formControlName="endHour" />
                  <mat-timepicker-toggle rds-control-suffix [for]="endPicker" />
                  <mat-timepicker #endPicker />
                  @if (bookingDetailsForm.errors?.['timeNotValid']) {
                    <rds-control-error>
                      End time should be after start time
                    </rds-control-error>
                  }
                </rds-form-field>
              </div>
            </div>
            <div class="row mt-7">
              <div class="col-4">
                <rds-switch [formControl]="customSetupTime">
                  Custom Setup Time
                </rds-switch>
              </div>
              @if (customSetupTime.value) {
                <div class="col-6">
                  <div class="flex align-items-baseline mb-7">
                    <rds-form-field labelPosition="top">
                      <rds-control-label>Time before</rds-control-label>
                      <input
                        type="number"
                        formControlName="customSetupTimeBeforeH"
                        rdsInput />
                      <span rds-control-suffix>h</span>
                      @if (
                        bookingDetailsForm.controls.customSetupTimeBeforeH
                          .errors?.['min']
                      ) {
                        <rds-control-error>
                          Value cannot be negative
                        </rds-control-error>
                      }
                    </rds-form-field>
                    <rds-form-field labelPosition="top">
                      <rds-control-label> </rds-control-label>
                      <input
                        type="number"
                        formControlName="customSetupTimeBeforeM"
                        rdsInput />
                      <span rds-control-suffix>m</span>
                      @if (
                        bookingDetailsForm.controls.customSetupTimeBeforeM
                          .errors?.['min']
                      ) {
                        <rds-control-error>
                          Value cannot be negative
                        </rds-control-error>
                      }
                      @if (
                        bookingDetailsForm.controls.customSetupTimeBeforeM
                          .errors?.['max']
                      ) {
                        <rds-control-error>
                          Value cannot exceed 59
                        </rds-control-error>
                      }
                    </rds-form-field>
                  </div>
                  <div class="flex align-items-baseline">
                    <rds-form-field labelPosition="top">
                      <rds-control-label>Time after</rds-control-label>
                      <input
                        type="number"
                        formControlName="customSetupTimeAfterH"
                        rdsInput />
                      <span rds-control-suffix>h</span>
                      @if (
                        bookingDetailsForm.controls.customSetupTimeAfterH
                          .errors?.['min']
                      ) {
                        <rds-control-error>
                          Value cannot be negative
                        </rds-control-error>
                      }
                    </rds-form-field>
                    <rds-form-field labelPosition="top">
                      <rds-control-label> </rds-control-label>
                      <input
                        type="number"
                        formControlName="customSetupTimeAfterM"
                        rdsInput />
                      <span rds-control-suffix>m</span>
                      @if (
                        bookingDetailsForm.controls.customSetupTimeAfterM
                          .errors?.['min']
                      ) {
                        <rds-control-error>
                          Value cannot be negative
                        </rds-control-error>
                      }
                      @if (
                        bookingDetailsForm.controls.customSetupTimeAfterM
                          .errors?.['max']
                      ) {
                        <rds-control-error>
                          Value cannot exceed 59
                        </rds-control-error>
                      }
                    </rds-form-field>
                  </div>
                </div>
              }
            </div>
            <div class="col-6">
              <div class="input-wrapper">
                <rds-form-field labelPosition="top">
                  <rds-control-label>WBS</rds-control-label>
                  <input rdsInput formControlName="wbsCode" />
                </rds-form-field>
              </div>
              <div class="input-wrapper">
                <rds-form-field labelPosition="top">
                  <rds-control-label>Cost Center</rds-control-label>
                  <input rdsInput formControlName="costCenter" />
                  @if (bookingDetailsForm.controls.costCenter.invalid) {
                    <rds-control-error
                      >Cost center should have 10 alphanumeric
                      characters</rds-control-error
                    >
                  }
                </rds-form-field>
              </div>
              @if (
                availableServices.length > 0 || unavailableServices().length > 0
              ) {
                <div class="col-6">
                  <p class="ui-label-l">Request Additional Services</p>
                  @for (service of availableServices; track service.id) {
                    <div [formGroup]="roomServicesForm">
                      <rds-checkbox formControlName="{{ service.type }}">
                        {{ service.name }}
                      </rds-checkbox>
                      @for (
                        eventService of eventDetail.bookingDetails.services;
                        track eventService.id
                      ) {
                        @if (
                          eventService.serviceType === service.type &&
                          eventService.ticketName
                        ) {
                          <a
                            [href]="eventService.url"
                            class="me-2"
                            target="_blank">
                            {{ eventService.ticketName }}
                          </a>
                          <rds-badge
                            size="s"
                            [label]="eventService.ticketStatus ?? 'unknown'"
                            color="neutral">
                          </rds-badge>
                        }
                      }
                      @if (
                        roomServicesForm.get(service.type)?.value &&
                        service.description
                      ) {
                        <p class="ui-label-s">
                          {{ service.description }}
                        </p>
                      }
                    </div>
                  }
                  @if (unavailableServices().length > 0) {
                    <p class="ui-label-l mt-4">Unavailable Services</p>
                    @for (
                      service of unavailableServices();
                      track service.serviceType
                    ) {
                      <div>
                        <rds-checkbox disabled [checked]="!isEditMode()">
                          {{ service.serviceType | titlecase }} Service
                        </rds-checkbox>
                      </div>
                    }
                  }
                </div>
              }
            </div>
          </div>
          @if (eventDetail.roomDetails.generalQuestionsEnabled) {
            <div class="row">
              <div class="col-4">
                <rds-form-field labelPosition="top">
                  <rds-control-label> CEC on site? </rds-control-label>
                  <rds-select formControlName="cecOnSite" placeholder="Yes/No">
                    <rds-select-option [value]="true">Yes</rds-select-option>
                    <rds-select-option [value]="false">No</rds-select-option>
                  </rds-select>
                </rds-form-field>
              </div>
              <div class="col-4">
                <rds-form-field labelPosition="top">
                  <rds-control-label> HCP on site? </rds-control-label>
                  <rds-select formControlName="hcpOnSite" placeholder="Yes/No">
                    <rds-select-option [value]="true">Yes</rds-select-option>
                    <rds-select-option [value]="false">No</rds-select-option>
                  </rds-select>
                </rds-form-field>
              </div>
              <div class="col-4">
                <rds-form-field labelPosition="top">
                  <rds-control-label>
                    More than 20 Externals?
                  </rds-control-label>
                  <rds-select
                    formControlName="moreThan20Externals"
                    placeholder="Yes/No">
                    <rds-select-option [value]="true">Yes</rds-select-option>
                    <rds-select-option [value]="false">No</rds-select-option>
                  </rds-select>
                </rds-form-field>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
